import React, { useState } from 'react'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NetworkPart2 from '../Reports/Network/NetworkInternalCertinReport/Part2/NetworkPart2';
import NetworkPart3 from '../Reports/Network/NetworkInternalCertinReport/Part3/NetworkPart3';
import NetworkPart1 from '../Reports/Network/NetworkInternalCertinReport/Part1/NetworkPart1';
import {Icon} from '@iconify/react'

function NetworkHTMLReport(props) {

    const {
        certInNetworkClientName, setCertInNetworkClientName,
        certInNetworkDate, setCertInNetworkDate, certInNetworkConsultantName, setCertInNetworkConsultantName,
        certInNetworkCustomerName, setCertInNetworkCustomerName,
        certInNetworkLogo, setCertInNetworkLogo,
        certInNetworkApplicationIP, setCertInNetworkApplicationIP,
        certInNetworkStartDate, setCertInNetworkStartDate,
        certInNetworkEndDate, setCertInNetworkEndDate,
        certInNetworkTestingype, setCertInNetworkTestingType,
        certInNetworkAppDescription, setCertInNetworkAppDescription,
        certInNetworkAppEnvironment, setCertInNetworkAppEnvironment,
        criticalityNetwork, setCriticalityNetwork,
        imageUrlNetwork, setImageUrlNetwork,
        inchargeNameNetwork, setInchargeNameNetwork,
        inchargeEmailNetwork, setInchargeEmailNetwork,
        inchargeDesignationNetwork, setInchargeDesignationNetwork,
        certInNetworkDownloading, setCertInNetworkownloading,
        certInNetworkVulnerabilities, setCertInNetworkVulnerabilities,
        certInNetworkVulCount, setCertInNetworkVulCount,
        certInNetworkCritical, setCertInNetworkCritical,
        certInNetworkHigh, setCertInNetworkHigh,
        certInNetworkMedium, setCertInNetworkMedium,
        certInNetworkLow, setCertInNetworkLow,
        handleCertInNetworkDownload, handleCertInNetworkPhase1Download
    } = props


    const [openNetworkCertInInputs, setNetworkCertInOpenInputs] = useState(false)
    const [certInNetworkCurrentPage, setCertInNetworkCurrentPage] = useState(1);

    const [openNetworkCertinCancel, setOpenNetworkCertinCancel] = useState(false)

    const [clientLogoSelected, setClientLogoSelected] = useState(false)
    const [clientLogoFetched, setClientLogoFetched] = useState(false)

    const [isImageSelected, setIsImageSelected] = useState(false);

    function capitalizeFirstLetter(string) {
        if (typeof string !== 'string') {
            return string;
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const handleCertInNetworkCancel = () => {
        setOpenNetworkCertinCancel(true)
    }

    const handleCertInNetworkDataCancel = () => {
        setOpenNetworkCertinCancel(false)
        setNetworkCertInOpenInputs(false)
        setCertInNetworkClientName([])
        setCertInNetworkDate('')
        setCertInNetworkConsultantName([])
        setCertInNetworkCustomerName('')
        setCertInNetworkLogo(null)
        setCertInNetworkApplicationIP('')
        setCertInNetworkStartDate('')
        setCertInNetworkEndDate('')
        setCertInNetworkTestingType('')
        setCertInNetworkAppDescription('')
        setCertInNetworkAppEnvironment('')
        setCriticalityNetwork('')
        setInchargeNameNetwork('')
        setInchargeEmailNetwork('')
        setInchargeDesignationNetwork('')
        setCertInNetworkVulnerabilities([])
        setCertInNetworkVulCount('')
        setCertInNetworkCritical('')
        setCertInNetworkHigh('')
        setCertInNetworkMedium('')
        setCertInNetworkLow('')
    }

    const handleNextPage = () => {
        setCertInNetworkCurrentPage(certInNetworkCurrentPage + 1);
    }

    const handlePrevPage = () => {
        if (certInNetworkCurrentPage > 1) {
            setCertInNetworkCurrentPage(certInNetworkCurrentPage - 1);
        }
    }

    const handleNetworkOpenInputs = () => {
        setNetworkCertInOpenInputs(true)
        setCertInNetworkCurrentPage(1)
    }

    return (
        <div className='wrap_report_data'>

            <div className='wrap_report_networkpart'>
                <div className='networkpart'
                    onClick={handleNetworkOpenInputs}>
                    <h1>Network CERT-In Report</h1>
                    <h2>Includes:</h2>
                    <p>Network CERT-In Report</p>
                    <p>Network CERT-In Audit Report</p>
                </div>
                <div className='wrap_globe_network'>
                    <div><i><Icon icon="bxs:network-chart" width="35" height="35" /></i></div>
                </div>
            </div>


            {openNetworkCertInInputs && (
                <div>
                    {certInNetworkCurrentPage === 1 && <NetworkPart1
                        clientLogoSelected={clientLogoSelected}
                        setClientLogoSelected={setClientLogoSelected}
                        clientLogoFetched={clientLogoFetched}
                        setClientLogoFetched={setClientLogoFetched}
                        isImageSelected={isImageSelected}
                        setIsImageSelected={setIsImageSelected}
                        certInNetworkDate={certInNetworkDate}
                        setCertInNetworkDate={setCertInNetworkDate}
                        certInNetworkCustomerName={certInNetworkCustomerName}
                        setCertInNetworkCustomerName={setCertInNetworkCustomerName}
                        certInNetworkLogo={certInNetworkLogo}
                        setCertInNetworkLogo={setCertInNetworkLogo}
                        certInNetworkApplicationIP={certInNetworkApplicationIP}
                        setCertInNetworkApplicationIP={setCertInNetworkApplicationIP}
                        certInNetworkStartDate={certInNetworkStartDate}
                        setCertInNetworkStartDate={setCertInNetworkStartDate}
                        certInNetworkEndDate={certInNetworkEndDate}
                        setCertInNetworkEndDate={setCertInNetworkEndDate}
                        certInNetworkTestingype={certInNetworkTestingype}
                        setCertInNetworkTestingType={setCertInNetworkTestingType}
                        certInNetworkAppDescription={certInNetworkAppDescription}
                        setCertInNetworkAppDescription={setCertInNetworkAppDescription}
                        certInNetworkAppEnvironment={certInNetworkAppEnvironment}
                        setCertInNetworkAppEnvironment={setCertInNetworkAppEnvironment}
                        criticalityNetwork={criticalityNetwork}
                        setCriticalityNetwork={setCriticalityNetwork}
                        imageUrlNetwork={imageUrlNetwork}
                        setImageUrlNetwork={setImageUrlNetwork}
                        certInNetworkDownloading={certInNetworkDownloading}
                        setCertInNetworkownloading={setCertInNetworkownloading}
                        certInNetworkVulnerabilities={certInNetworkVulnerabilities}
                        setCertInNetworkVulnerabilities={setCertInNetworkVulnerabilities}
                        certInNetworkCurrentPage={certInNetworkCurrentPage}
                        setCertInNetworkCurrentPage={setCertInNetworkCurrentPage}
                        handleCertInNetworkCancel={handleCertInNetworkCancel}
                        handleCertInNetworkDataCancel={handleCertInNetworkDataCancel}
                        capitalizeFirstLetter={capitalizeFirstLetter}
                        handleNextPage={handleNextPage}
                        handleCertInNetworkDownload={handleCertInNetworkDownload}
                        handleCertInNetworkPhase1Download={handleCertInNetworkPhase1Download}
                        certInNetworkClientName={certInNetworkClientName}
                        setCertInNetworkClientName={setCertInNetworkClientName}
                        certInNetworkConsultantName={certInNetworkConsultantName}
                        setCertInNetworkConsultantName={setCertInNetworkConsultantName}
                    />}

                    {certInNetworkCurrentPage === 2 && (
                        <NetworkPart2
                            inchargeNameNetwork={inchargeNameNetwork}
                            setInchargeNameNetwork={setInchargeNameNetwork}
                            inchargeEmailNetwork={inchargeEmailNetwork}
                            setInchargeEmailNetwork={setInchargeEmailNetwork}
                            inchargeDesignationNetwork={inchargeDesignationNetwork}
                            setInchargeDesignationNetwork={setInchargeDesignationNetwork}
                            certInNetworkDownloading={certInNetworkDownloading}
                            setCertInNetworkownloading={setCertInNetworkownloading}
                            certInNetworkVulnerabilities={certInNetworkVulnerabilities}
                            setCertInNetworkVulnerabilities={setCertInNetworkVulnerabilities}
                            certInNetworkCurrentPage={certInNetworkCurrentPage}
                            setCertInNetworkCurrentPage={setCertInNetworkCurrentPage}
                            handleCertInNetworkCancel={handleCertInNetworkCancel}
                            handleCertInNetworkDataCancel={handleCertInNetworkDataCancel}
                            capitalizeFirstLetter={capitalizeFirstLetter}
                            handleNextPage={handleNextPage}
                            handleCertInNetworkDownload={handleCertInNetworkDownload}
                            certInNetworkVulCount={certInNetworkVulCount}
                            setCertInNetworkVulCount={setCertInNetworkVulCount}
                            certInNetworkCritical={certInNetworkCritical}
                            setCertInNetworkCritical={setCertInNetworkCritical}
                            certInNetworkHigh={certInNetworkHigh}
                            setCertInNetworkHigh={setCertInNetworkHigh}
                            certInNetworkMedium={certInNetworkMedium}
                            setCertInNetworkMedium={setCertInNetworkMedium}
                            certInNetworkLow={certInNetworkLow}
                            setCertInNetworkLow={setCertInNetworkLow}
                            handlePrevPage={handlePrevPage}
                            // handleCertInNetworkCancel={handleCertInNetworkCancel}
                            handleCertInNetworkPhase1Download={handleCertInNetworkPhase1Download}
                        />
                    )}

                    {certInNetworkCurrentPage === 3 && (
                        <NetworkPart3
                            handlePrevPage={handlePrevPage}
                            handleCertInNetworkCancel={handleCertInNetworkCancel}
                            handleNextPage={handleNextPage}
                            handleCertInNetworkDownload={handleCertInNetworkDownload}
                            certInNetworkVulnerabilities={certInNetworkVulnerabilities}
                            setCertInNetworkVulnerabilities={setCertInNetworkVulnerabilities}
                            certInNetworkCurrentPage={certInNetworkCurrentPage}
                            setCertInNetworkCurrentPage={setCertInNetworkCurrentPage}
                            handleCertInNetworkDataCancel={handleCertInNetworkDataCancel}
                        />
                    )}
                </div>
            )}

            {openNetworkCertinCancel && (
                <div className='waiting_page'>
                    <div className='wrap_Waiting'>
                        <div className='wrap_waitingpage_icon'><i><FontAwesomeIcon icon={faExclamationCircle} /></i></div>
                        <h2>Canceling this action will result in the permanent loss of data, which cannot be recovered.</h2>
                        <div >
                            <button className='wrap_waiting_cancelbutton' onClick={() => setOpenNetworkCertinCancel(false)}>Cancel</button>
                            <button className='wrap_waiting_confirmbutton' onClick={handleCertInNetworkDataCancel}>Confirm</button>
                        </div>
                    </div>
                </div>
            )}



        </div>
    )
}

export default NetworkHTMLReport
